import { useMemo } from "react";
import { get as lodashGet } from "lodash-es";
import { FEATURE_FLAGS } from "main/src/modules/common/constants";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";
import type { InstanceConfiguration } from "@certa/queries/types/config.types";

export const useGetOrphanKinds = (): string[] => {
  const { data: config } = useInstanceConfigQuery();
  const featureToggles = lodashGet(
    config,
    "feature_toggles",
    {} as InstanceConfiguration["feature_toggles"]
  );
  const isLinkDelinkOrphanFeatureEnabled =
    featureToggles[FEATURE_FLAGS.ENABLE_WORKFLOW_LINK_DELINK_FEATURE] || false;

  const orphanKinds = useMemo(
    () =>
      isLinkDelinkOrphanFeatureEnabled
        ? lodashGet(config, "orphan_kinds", [])
        : [],
    [isLinkDelinkOrphanFeatureEnabled, config]
  );

  return orphanKinds || [];
};
